import React, { useState, useRef, useEffect, useContext } from "react";
import "./ContestScreen.scss";
import moment from "moment";
import OwlCarousel from 'react-owl-carousel';
import { Grid, Image } from 'semantic-ui-react'
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux'
import { listAllTrivias } from '../../store/TriviaRedux'
import { useTranslation } from "react-i18next";
import { mainContestListingSlider } from "../../store/TriviaRedux"
import Countdown from 'react-countdown';
import { ContestTab, StarButton } from '../../components'
import { Config } from "../../common"


const ContestScreen = () => {
  const history = useHistory();
  const dispatch = useDispatch()
  const token = useSelector((state) => state.auth.token)
  const mainContestListing = useSelector((state) => state.trivia.mainContestListing)
  const { t, i18n } = useTranslation();
  const [sliders, setSliders] = useState([])


  useEffect(() => {
    dispatch(mainContestListingSlider({ token }))
    dispatch(listAllTrivias({ token }))
    window.scrollTo(0, 0)
  }, []);


  useEffect(() => {
    setSliders(JSON.parse(JSON.stringify(mainContestListing)))
  }, [i18n.language && mainContestListing]);

  const renderer = ({ days, hours, minutes, seconds }) => {
    return <div className="calender_sec clearall">
      <div className="carryminer">
        <h3>{days}</h3>
        <p>DAY(S)</p>
      </div>
      <div className="dot_sec">:</div>
      <div className="carryminer">
        <h3>{hours}</h3>
        <p>HOUR(S)</p>
      </div>
      <div className="dot_sec">:</div>
      <div className="carryminer">
        <h3>{minutes}</h3>
        <p>MINUTE(S)</p>
      </div>
    </div>
  };

  const contestBanner = () => {
    return <div id="contestBanner">
      {sliders.length > 0 ? <OwlCarousel className='owl-theme' loop items={1} nav>
        {sliders.map((item, key) => {
          let newDate = moment.utc(item?.contest?.endDate) - moment.utc(Config.localUtc())
          let basicDetails = Config.GetLanguage(item?.contest, i18n.language, 'basicDetails')
          return <div key={key} className="item" style={{ background: `url(${item?.contest?.mainContestListingImage}) no-repeat`, backgroundSize: 'cover', }}>
            <Grid className="banner" verticalAlign='middle'>
              <Grid.Column computer={6} mobile={16} tablet={6}>
                <div className="mobiles"><Image className="conteststar" src={item?.contest?.mainContestListingMobileViewImage} /></div>
              </Grid.Column>
              <Grid.Column computer={10} mobile={16} tablet={10}>
                <div className="meet">
                  <h1>{basicDetails?.title}</h1>
                  <div className="yellow_border"></div>
                  <Countdown date={Date.now() + newDate}
                    renderer={renderer}
                  />
                  <div className="contests">
                    <Grid verticalAlign='middle' className="btn-grid">
                      <Grid.Column mobile={16} tablet={8} computer={8}>
                        <StarButton background={'mainBg'} title={t("contest.btn")} onClickAction={() => history.push(`/landing/${item?.contest?._id}`)} />
                      </Grid.Column>
                      <Grid.Column mobile={16} tablet={8} computer={8}>
                        <div className="registration">
                          <i className="fa fa-circle" aria-hidden="true"></i> <span>{(item?.contest?.players)?.length} Active Participations</span>
                        </div>
                      </Grid.Column>
                    </Grid>
                  </div>
                </div>
              </Grid.Column>
            </Grid>
          </div>
        }
        )}
      </OwlCarousel> : null}
    </div>
  }

  return (
    <>
      <div className="containerfluid clearall">
        <div className="bg">
          {contestBanner()}
          <div className="navication clearall">
            <div className="ipsum">
              <h5>{t("contest.titel2")}</h5>
              <h6>{t("contest.para")}</h6>
            </div>
          </div>
          <ContestTab />
        </div>
      </div>
    </>
  );
};
export default ContestScreen
